export class AdvancedNewsEnvironment {
  public static getName = () => 'benzinga-advanced-news';
  public static getEnvironment = (env: Record<string, string>) => ({
    'CF-Access-Client-Id': '8283325bece138df11d232f98bfcb4d5.access',
    'CF-Access-Client-Secret': 'b9190b14fe080627f5e7f6720b67ed99b6b97fbb2f6d66e9f9017a7e08e2f59d',
    contentKey: env.contentKey ?? 'TkWiPBzZ5YdSlzmEblWB8eTljd5kXvmb6zNy',
    contentUrl: new URL(env.contentURL ?? 'https://content-internal.benzinga.com/content/'),
    internalContentUrl: new URL(env.internalContentUrl ?? 'http://content-server-next.pro-backend'),
    keepSocketAlive: env.keepSocketAlive ?? 'false',
    socketUrl: new URL(env.socketUrl ?? 'wss://api-pro.benzinga.com/api/v3/news/advanced/ws'),
    url: new URL(env.url ?? 'https://www.benzinga.com/'),
  });
}
